import request from '@/utils/zsm-requets'
var share='/zsm/api/share/'
/** 新增分享数据
   cover封面
   goodId 商品
   goodName 商品名称
   platformDict平台
   distId分享人
   distName分享名称
   title分享标题

 */
export function createShare(params) {
  return request({
    url: share+'create',
    method: 'post',
    params
  })
}



/**
 * 发布抖音视频
 */
export function createVideoShare(params) {
  return request({
    url: share+'createVideo',
    method: 'post',
    params
  })
}






/**
 * 上传素材图片
 *
 *filePath
  frontId
 */
export function uploadImageShare(filePath,frontId) {
  return request({
    url: share+'uploadImage',
    method: 'post',
    params:{filePath,frontId}
  })
}



/**
 * 上传素材视频
 *
 *filePath
  frontId
 */
export function uploadVideoShare(filePath,frontId) {
  return request({
    url: share+'uploadVideo',
    method: 'post',
    params:{filePath,frontId}
  })
}


/**
  获取分享列表 distId
 */
export function listDataShare(params) {
  return request({
    url: share+'listData',
    method: 'post',
    params
  })
}


/**
   删除分享列表和抖音视频
 */
export function deleteShare(id) {
  return request({
    url: share+'delete',
    method: 'post',
    params:{id}
  })
}
